import React from "react";
import propTypes from "prop-types";
import { useFormContext } from "./Form";
import { getId } from "./field";

const Label = ({ input, option, children, ...props }) => {
    const context = useFormContext();
    const id = getId(input, context, option);

    return <label htmlFor={id} {...props}>{ children }</label>;
};

Label.propTypes = {
    input: propTypes.string.isRequired,
    option: propTypes.oneOfType([
        propTypes.string,
        propTypes.number,
    ]),
    children: propTypes.any,
};

export default Label;
